import { isAxiosError, isCancel } from "axios";

const NEVER_COMPLETED_CODES = new Set(["ERR_NETWORK", "ERR_CANCELED", "ECONNABORTED", "ETIMEDOUT"]);

export function isNetworkError(err: unknown): boolean {
  if (isCancel(err)) {
    return true;
  }

  if (!isAxiosError(err) || err.response) {
    return false;
  }

  return err.code === undefined || NEVER_COMPLETED_CODES.has(err.code);
}
